import i18n from '@/locales'
export default {
  created () {
    this.singleActions = [
      {
        label: i18n.t('common.action.delete'),
        permission: 'shieldbills_delete',
        action: (obj) => {
          this.createDialog('DeleteResDialog', {
            vm: this,
            data: [obj],
            columns: this.columns,
            title: this.$t('common.delete'),
            name: this.$t('bill.bill_config'),
            onManager: this.onManager,
          })
        },
      },
    ]
  },
}
